var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 25.6667C5 20.512 9.02943 16.3333 14 16.3333C18.9706 16.3333 23 20.512 23 25.6667H20.75C20.75 21.8007 17.7279 18.6667 14 18.6667C10.2721 18.6667 7.25 21.8007 7.25 25.6667H5ZM14 15.1667C10.2706 15.1667 7.25 12.0342 7.25 8.16667C7.25 4.29917 10.2706 1.16667 14 1.16667C17.7294 1.16667 20.75 4.29917 20.75 8.16667C20.75 12.0342 17.7294 15.1667 14 15.1667ZM14 12.8333C16.4862 12.8333 18.5 10.745 18.5 8.16667C18.5 5.58833 16.4862 3.5 14 3.5C11.5138 3.5 9.5 5.58833 9.5 8.16667C9.5 10.745 11.5138 12.8333 14 12.8333Z",
    fill: "#005F73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.fd1b2b4258443fdf73a6be0a37675615.svg";
export { ForwardRef as ReactComponent };